/**
 * Shared emp code / name search for payroll & attendance employee tables.
 */

function pushPart(parts, v) {
  const s = String(v ?? "").trim();
  if (s) parts.push(s);
}

/** Build a lowercase haystack from common employee row shapes. */
export function getEmpSearchHaystack(row) {
  if (!row || typeof row !== "object") return "";
  const nested = row.employee || row.e || null;
  const user = row.user || nested?.user || null;
  const parts = [];
  pushPart(parts, row.empCode);
  pushPart(parts, row.employeeCode);
  pushPart(parts, row.code);
  pushPart(parts, row.empId);
  pushPart(parts, row.name);
  pushPart(parts, row.empName);
  pushPart(parts, row.employeeName);
  pushPart(parts, nested?.empCode);
  pushPart(parts, nested?.employeeCode);
  pushPart(parts, nested?.code);
  pushPart(parts, nested?.name);
  pushPart(parts, nested?.firstName);
  pushPart(parts, nested?.lastName);
  pushPart(parts, user?.name);
  pushPart(parts, user?.lastName);
  if (nested?.firstName || nested?.lastName) {
    pushPart(parts, [nested.firstName, nested.lastName].filter(Boolean).join(" "));
  }
  return parts.join(" ").toLowerCase();
}

export function filterRowsByEmpCodeOrName(rows, query) {
  const list = Array.isArray(rows) ? rows : [];
  const q = String(query || "")
    .trim()
    .toLowerCase();
  if (!q) return list;
  return list.filter((row) => getEmpSearchHaystack(row).includes(q));
}
